export default (props, vars) =>
  !vars?.['uselookbook2']?.['isLoading'] &&
  !!vars?.['uselookbook2']?.['lookbook'];
